export const STYLE_TYPES = {
    INLINE: 'INLINE',
    BLOCK: 'BLOCK',
};

export const STYLE_COMMANDS = {
    BOLD: 'BOLD',
    ITALIC: 'ITALIC',
    UNDERLINE: 'UNDERLINE',
    LARGE_HEADING: 'header-one',
    HEADING: 'header-two',
    BLOCKQUOTE: 'blockquote',
    CODE: 'CODE',
    CODE_BLOCK: 'code-block',
    STRIKETHROUGH: 'STRIKETHROUGH',
    CENTER_TEXT: 'CENTER-TEXT',
    LIST: 'unordered-list-item',
    ORDERED_LIST: 'ordered-list-item',
    CHECKLIST: 'checklist',
    UNSTYLED: 'unstyled',
    SMALL_TEXT: 'small-text',
    HEADING_PREFIX: 'header',
    // Needs to match the one within the
    HYPERLINK: 'LINK',
    HIGHLIGHT: 'HIGHLIGHT',

    // Text alignment
    ALIGN_CENTER: 'ALIGN_CENTER',
};

export const STYLE_COMMAND_TYPES = {
    [STYLE_COMMANDS.BOLD]: STYLE_TYPES.INLINE,
    [STYLE_COMMANDS.ITALIC]: STYLE_TYPES.INLINE,
    [STYLE_COMMANDS.UNDERLINE]: STYLE_TYPES.INLINE,
    [STYLE_COMMANDS.LARGE_HEADING]: STYLE_TYPES.BLOCK,
    [STYLE_COMMANDS.HEADING]: STYLE_TYPES.BLOCK,
    [STYLE_COMMANDS.BLOCKQUOTE]: STYLE_TYPES.BLOCK,
    [STYLE_COMMANDS.CODE]: STYLE_TYPES.INLINE,
    [STYLE_COMMANDS.CODE_BLOCK]: STYLE_TYPES.BLOCK,
    [STYLE_COMMANDS.STRIKETHROUGH]: STYLE_TYPES.INLINE,
    [STYLE_COMMANDS.LIST]: STYLE_TYPES.BLOCK,
    [STYLE_COMMANDS.ORDERED_LIST]: STYLE_TYPES.BLOCK,
    [STYLE_COMMANDS.SMALL_TEXT]: STYLE_TYPES.BLOCK,

    [STYLE_COMMANDS.CHECKLIST]: STYLE_TYPES.BLOCK,
    [STYLE_COMMANDS.HIGHLIGHT]: STYLE_TYPES.INLINE,
};

export const ENTITIES = {
    LINK: 'LINK',
    CLIP: 'CLIP',
    MENTION: 'mention',
};

export const BLOCK_METADATA = {
    TEXT_ALIGN_CENTER: 'text-align-center',
    IGNORE_FOR_DELETE: 'ignore-for-delete',
    HEADER_TITLE: 'header-title',
};
